import React, { useState, useEffect } from "react";
import { Box, Grid } from "@mui/material";
import DialogComponent from "../../../../component/atom/Dialog/Dialog";
import HeadingComponent from "../../../../component/atom/Headings/Heading";
import AdminCourseWeekContent from "../../../../component/molecule/Forms/courseAdmin/AdminCourseWeekContent";
import AdminCourseContentEditForm from "../../../../component/molecule/Forms/courseAdmin/AdminCourseContentEditForm";
import AdminCourseSectionEditForm from "../../../../component/molecule/Forms/courseAdmin/AdminCourseSectionEditForm";
import AdminCourseWeekQuiz from "../../../../component/molecule/Forms/courseAdmin/AdminCourseWeekQuiz";
import AdminCourseWeekDocument from "../../../../component/molecule/Forms/courseAdmin/AdminCourseWeekDocument";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import { useParams, useLocation } from "react-router-dom";
import { faAdd } from "@fortawesome/free-solid-svg-icons";
import { Actions } from "../../../../core/modules/Actions";
import { connect } from "react-redux";
import _ from "lodash";
import { PopUpMessageComponent } from "../../../../component/molecule";
import { renderTruncatedText } from "../../../../core/Constant";
import CourseContentTable from "../../../../component/atom/Table/CourseContentTable";
import {
  IconButtonComponent,
  TextIconButtonComponent,
} from "../../../../component/atom";

const AdminCourseContentEdit = ({
  getCourseContent,
  courseContent,
  getCourseMainDetails,
  mainDetailsState,
  deleteCourseContent,
  rearrangeContent,
}) => {
  const location = useLocation();
  const params = useParams();
  const [scroll, setScroll] = useState("paper");
  const [courseName, setCourseName] = useState("");
  const [expanded, setExpanded] = useState(1);
  const [existingWeekCount, setExistingWeekCount] = useState(0);
  const [existingWeekArray, setExistingWeekArray] = useState([]);
  const [existingWeekData, setExistingWeekData] = useState([]);
  const [weekContent, setWeekContent] = useState(false);
  const [updateContentData, setUpdateContentData] = useState("");
  const [newContentDay, setNewContentDay] = useState(0);
  const [contentAddingWeekNo, setContentAddingWeekNo] = useState(0);
  const [updateContentModal, setUpdateContentModal] = useState(false);
  const [maxWeekCount, setMaxWeekCount] = useState(0);
  const [weekQuiz, setWeekQuiz] = useState(false);
  const [id, setId] = useState("");
  const [confirmDeleteContent, setConfirmDeleteContent] = useState(false);
  const [courseContentDetails, setCourseContentDetails] = useState({
    course_id: 0,
    course_content_id: 0,
  });
  const [updateSectionModal, setUpdateSectionModal] = useState(false);
  const [selectedSectionDetails, setSelectedSectionDetails] = useState({
    section_id: 0,
    section_name: "",
  });
  const [sectionState, setSectionState] = useState(0);
  const [modalTitle, setModalTitle] = useState(0);
  const [selectedSectionName, setSelectedSectionName] = useState("");
  const [updateSectionName, setUpdateSectionName] = useState("");
  const [bindDocModal, setBindDocModal] = useState(false);
  const [selectedBindDetails, setSelectedBindDetails] = useState({
    courseId: "",
    sectionId: "",
    expanded: "",
  });
  const [contentList, setContentList] = useState([]);
  const courseId = _.get(location, "state.id", _.get(params, "id"));

  useEffect(() => {
    if (courseId && courseId !== "undefined") {
      getCourseContent(courseId);
      getCourseMainDetails({
        id: courseId,
      });
      setId(courseId);
    }
  }, [courseId]);


  useEffect(() => {
    if (location?.state?.expanded) {
      setExpanded(location.state.expanded);
    }
  }, [location]);

  useEffect(() => {
    setCourseName(mainDetailsState.name);
    setMaxWeekCount(mainDetailsState.duration);

    var weekArray = [];
    for (let i = 0; i < courseContent.length; i++) {
      if (!weekArray.includes(courseContent[i].week)) {
        weekArray.push(courseContent[i].week);
      }
    }
    setExistingWeekCount(weekArray.length);
    setExistingWeekArray(weekArray);

    setExistingWeekData(courseContent);
  }, [mainDetailsState, courseContent]);

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const addInputField = () => {
    setContentAddingWeekNo(1);
    setNewContentDay(1);
    setWeekContent(true);
  };

  const addNewWeekSection = () => {
    setContentAddingWeekNo(existingWeekArray.length + 1);
    setNewContentDay(1);
    setSectionState(0);
    setModalTitle("Create New Section Content");
    setWeekContent(true);
  };

  function filterVideo(values) {
    return String(values.content_type) == "1";
  }

  const dayContentModalLoad = (week, sectionName) => {
    var weekDayCount = 0;
    if (existingWeekArray.length != 0) {
      const contentArray = courseContent[week - 1].content;
      weekDayCount = Object.values(contentArray).filter(filterVideo).length;
    }

    setNewContentDay(weekDayCount + 1);
    setContentAddingWeekNo(week);
    setSectionState(1);
    setModalTitle("Add New Content - " + sectionName);
    setSelectedSectionName(sectionName);
    setWeekContent(true);
  };

  const loadContentEditModal = (contentData) => {
    setUpdateContentData(contentData);
    setUpdateSectionName(contentData.week);
    setUpdateContentModal(true);
  };

  const quizAddModalLoad = (week, sectionName) => {
    setContentAddingWeekNo(week);
    setSelectedSectionName(sectionName);
    setWeekQuiz(true);
  };

  const loadContentDeleteModal = (contentData) => {
    setCourseContentDetails({
      course_id: contentData.course_id,
      course_content_id: contentData.id,
    });
    setConfirmDeleteContent(true);
  };

  const deleteCourseContentbtn = () => {
    deleteCourseContent(
      courseContentDetails?.course_content_id,
      courseContentDetails.course_id
    );
    setConfirmDeleteContent(false);
  };

  const loadSectionEditModal = (sectionName, sectionId) => {
    setSelectedSectionDetails({
      section_id: sectionId,
      section_name: sectionName,
    });

    setUpdateSectionModal(true);
  };

  const contentName = courseName + " Course Content"

  useEffect(() => {
    setContentList(courseContent);
  }, [courseContent]);

  const DEFAULT_DAY = "1"

  // Drag and drop handler function
  const flattenWeekContent = (nestedContent) => {
    if (Array.isArray(nestedContent)) {
      return nestedContent.flat().sort((a, b) => {
        const dayA = a.day !== null && a.day !== undefined ? Number(a.day) : 1;
        const dayB = b.day !== null && b.day !== undefined ? Number(b.day) : 1;
        return dayA - dayB;
      });
    }

    return Object.keys(nestedContent)
      .sort((a, b) => {
        const dayA = Number(a.split("-")[0]);
        const dayB = Number(b.split("-")[0]);
        return dayA - dayB;
      })
      .reduce((acc, dayKey) => {
        const dayItems = nestedContent[dayKey] || [];
        return [...acc, ...dayItems];
      }, []);
  };

  const getSectionId = (weekContentData) => {
    const firstContent = flattenWeekContent(weekContentData)[0];
    return firstContent?.id ?? firstContent?.content_id ?? "";
  };

  const findFallbackDay = (list, targetIndex) => {
    // Look backward from target index
    const fallbackBefore = list
      .slice(0, targetIndex)
      .findLast((item) => item.day !== undefined && item.day !== null);
    // Look forward from target index
    if (fallbackBefore && fallbackBefore.day !== undefined && fallbackBefore.day !== null) {
      return fallbackBefore.day;
    }

    const fallbackAfter = list
      .slice(targetIndex)
      .find((item) => item.day !== undefined && item.day !== null);
    return fallbackAfter && fallbackAfter.day !== undefined && fallbackAfter.day !== null
      ? fallbackAfter.day
      : null;
  };

  const determineTargetDay = (list, destinationIndex, currentDay) => {
    const neighborBefore = list[destinationIndex - 1];
    const neighborAfter = list[destinationIndex];

    if (neighborBefore && neighborBefore.day !== undefined && neighborBefore.day !== null) {
      return neighborBefore.day;
    }

    if (neighborAfter && neighborAfter.day !== undefined && neighborAfter.day !== null) {
      return neighborAfter.day;
    }

    const fallback = findFallbackDay(list, destinationIndex);
    return fallback !== null ? fallback : currentDay;
  };

  const reconstructGroupedContent = (flatList) => {
    return flatList.reduce((acc, item) => {
      const isDayZero = item.day === 0 || item.day === "0";
      const baseDayVal = isDayZero ? "0" : String(item.day ?? "1");

      // Prevent Day 0 items from grouping together visually
      const groupKey = isDayZero ? `0-${item.id || item.content_id}` : baseDayVal;

      if (!acc[groupKey]) {
        acc[groupKey] = [];
      }
      acc[groupKey].push(item);
      return acc;
    }, {});
  };

  //drag and drop handler
  const onDragEnd = (result, weekIndex) => {
    const { destination, source } = result;
    if (!destination || destination.index === source.index) return;

    const updatedWeeks = [...contentList];
    const currentWeek = updatedWeeks[weekIndex];

    const flattenedContent = flattenWeekContent(currentWeek.content || {});
    const [reorderedItem] = flattenedContent.splice(source.index, 1);

    // Update the day value dynamically based on its drop location
    reorderedItem.day = determineTargetDay(flattenedContent, destination.index, reorderedItem.day);

    flattenedContent.splice(destination.index, 0, reorderedItem);

    updatedWeeks[weekIndex] = {
      ...currentWeek,
      content: reconstructGroupedContent(flattenedContent),
    };

    setContentList(updatedWeeks);
    persistReorderedContent(flattenedContent);
  };

  const persistReorderedContent = (reorderedItemsList) => {
    const rawContentData = reorderedItemsList
      ?.map((content) => ({
        content_id: content?.id ?? content?.content_id,
        day: content?.day,
      }))
      ?.filter((item) => item.content_id);

    if (!rawContentData || rawContentData.length === 0) return;

    const groupedByDay = rawContentData.reduce((acc, currentItem) => {
      const dayKey = currentItem.day;

      if (!acc[dayKey]) {
        acc[dayKey] = [];
      }

      acc[dayKey].push({
        content_id: currentItem.content_id,
        day: currentItem.day,
      });

      return acc;
    }, {});

    const structuredPayload = Object.values(groupedByDay);
    rearrangeContent({
      content_data: structuredPayload,
    });
  };

  return (
    <>
      <Box className="main-screen-container">
        <Grid container flexDirection={"column"} rowSpacing={4}>
          <Grid item>
            <Grid container justifyContent={'space-between'}>
              <Grid item>
                <HeadingComponent
                  text={renderTruncatedText(contentName, { limit: 30 })}
                  fontWeight={600}
                  size={30}
                  fontFamily={"Montserrat"}
                  backNavigation={true}

                />
              </Grid>
              <Grid item>
                <Grid container spacing={1}>
                  <Grid item>
                    <TextIconButtonComponent
                      btnText={"Add Section"}
                      icon={faAdd}
                      onclick={addNewWeekSection}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <Box >
              {contentList.length !== 0 ? (
                <>
                  {contentList.map((weekData, index) => (
                    <Box key={index}>
                      <Accordion
                        expanded={expanded === index + 1}
                        onChange={handleChange(index + 1)}
                      >
                        <AccordionSummary
                          style={{
                            backgroundColor: "rgba(131, 29, 220, 0.295)",
                          }}
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                        >
                          <Grid
                            container
                            alignItems="center"
                            justifyContent="space-between"
                          >
                            <Grid item style={{ display: "flex" }}>
                              <Typography p={1}>{weekData.week}</Typography>
                              <IconButtonComponent
                                btnType={"editbtn"}
                                onclick={() =>
                                  loadSectionEditModal(
                                    weekData.week,
                                    getSectionId(weekData.content)
                                  )
                                }
                              />
                            </Grid>

                            <Grid item style={{ display: "flex" }}>
                              <TextIconButtonComponent
                                style={{ marginRight: "5px" }}
                                btnText={"Add New Content"}
                                onclick={() =>
                                  dayContentModalLoad(
                                    index + 1,
                                    weekData.week
                                  )
                                }
                              />
                              &nbsp;
                              <TextIconButtonComponent
                                style={{ marginRight: "5px" }}
                                btnText={"Add Quiz"}
                                onclick={() =>
                                  quizAddModalLoad(
                                    index + 1,
                                    weekData.week
                                  )
                                }
                              />
                              &nbsp;
                              <TextIconButtonComponent
                                btnText={"Add Document"}
                                onclick={() => {
                                  setSelectedSectionName(existingWeekData[index].week)
                                  setSelectedBindDetails({
                                    courseId: id,
                                    sectionId: getSectionId(existingWeekData[index].content),
                                    expanded: index + 1,
                                  });
                                  setBindDocModal(true);
                                }}
                              />
                            </Grid>
                          </Grid>
                        </AccordionSummary>
                        <AccordionDetails>
                          <CourseContentTable
                            weekData={{
                              ...weekData,
                              content: reconstructGroupedContent(flattenWeekContent(weekData.content || {}))
                            }}
                            weekIndex={index}
                            onDragEnd={onDragEnd}
                            onEdit={loadContentEditModal}
                            onDelete={loadContentDeleteModal}
                          />
                        </AccordionDetails>
                      </Accordion>
                    </Box>
                  ))}
                </>
              ) : (
                <></>
              )}
            </Box>
          </Grid>
        </Grid>
      </Box>

      <DialogComponent
        title={modalTitle}
        open={weekContent}
        maxwidth={"lg"}
        onClose={() => setWeekContent(false)}
      >
        {weekContent && (
          <AdminCourseWeekContent
            open={weekContent}
            courseID={id}
            weekNo={contentAddingWeekNo}
            dayNo={newContentDay}
            dataState={sectionState}
            sectionName={selectedSectionName}
            onClose={() => setWeekContent(false)}
          />
        )}
      </DialogComponent>
      <DialogComponent
        title={"Quiz - " + selectedSectionName}
        open={weekQuiz}
        maxwidth={"lg"}
        onClose={() => setWeekQuiz(false)}
      >
        {weekQuiz && (
          <AdminCourseWeekQuiz
            open={weekQuiz}
            courseID={id}
            weekNo={contentAddingWeekNo}
            dayNo={newContentDay}
            sectionName={selectedSectionName}
            onClose={() => setWeekQuiz(false)}
          />
        )}
      </DialogComponent>

      <DialogComponent
        title={"Add Document - " + selectedSectionName}
        open={bindDocModal}
        onClose={() => setBindDocModal(false)}
        maxwidth="lg"
      >
        {bindDocModal && (
          <AdminCourseWeekDocument
            open={bindDocModal}
            courseID={id}
            sectionName={selectedSectionName}
            onClose={() => setBindDocModal(false)}
          />
        )}
      </DialogComponent>
      <DialogComponent
        title={"Update Content - " + updateSectionName}
        open={updateContentModal}
        onClose={() => setUpdateContentModal(false)}
      >
        {updateContentModal && (
          <AdminCourseContentEditForm
            courseContentData={updateContentData}
            onClose={() => setUpdateContentModal(false)}
          />
        )}
      </DialogComponent>

      <DialogComponent
        title={"Update Section Name"}
        open={updateSectionModal}
        onClose={() => setUpdateSectionModal(false)}
      >
        {updateSectionModal && (
          <AdminCourseSectionEditForm
            courseSectionData={selectedSectionDetails}
            onClose={() => setUpdateSectionModal(false)}
          />
        )}
      </DialogComponent>

      <PopUpMessageComponent
        open={confirmDeleteContent}
        type={"other"}
        title={"Delete!"}
        message={"Are you sure you want to delete this content?"}
        btntext={"Yes, delete"}
        onclick={() => deleteCourseContentbtn()}
        altbtntext={"No"}
        altonclick={() => setConfirmDeleteContent(false)}
        onclose={() => setConfirmDeleteContent(false)}
      />

    </>
  );
};

export default connect(
  (state) => ({
    mainDetailsState: state.course.get("mainDetailsState"),
    courseContent: state.course.get("courseContent"),
  }),
  {
    getCourseContent: Actions.course.getCourseContent,
    getCourseMainDetails: Actions.course.getCourseMainDetails,
    deleteCourseContent: Actions.course.deleteCourseContent,
    rearrangeContent: Actions.video.rearrangeContent,
  }
)(AdminCourseContentEdit);
